import styled, { css } from 'styled-components';
import { BorderColor2, DarkGreySidely2, PastelPrimaryColor, SidelyBlack } from './Utils';

export const TitleFontFamily = '"Radio Canada Big", sans-serif';

const DefaultText = css`
    font-size: 12px;
    font-style: normal;
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-feature-settings: normal;
    font-variant-numeric: normal;
    margin: 0;
    padding: 0;
    color: ${DarkGreySidely2};
`;

const DefaultTextBlack = css`
    ${DefaultText}
    color: ${SidelyBlack};
`;

export const DefaultTextDiv = styled.div<{ height?: string, fontSize?: string, color?: string }>`
    ${DefaultText}
    ${p => p.height ? `height: ${p.height};` : ''}
    ${p => p.fontSize ? `font-size: ${p.fontSize};` : ''}
    ${p => p.color ? `color: ${p.color};` : ''}
`;

const DefaultPlaceholder = css`
    ${DefaultText};
    color: ${BorderColor2};
`;

export const DefaultPlaceholderDiv = styled(DefaultTextDiv)`
    ${DefaultPlaceholder}
`;

const DefaultEditable = css`
    &:focus-visible {
        border: none;
        outline: none;
        background-color: ${PastelPrimaryColor};
    }
`;

export {
	DefaultText,
	DefaultTextBlack,
	DefaultEditable
};
